import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { trackSignup } from "@/lib/tracking";

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } })
      .then(({ data }) => {
        setUser(data);
        let dest = location.pathname.startsWith("/dashboard") ? location.pathname : "/dashboard";
        if (data.new_signup) { trackSignup(); dest = `/welcome?next=${encodeURIComponent(dest)}`; }
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true, state: { user: data } });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [location.hash, location.pathname, navigate, setUser]);

  return null;
}
